<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="学期名" prop="termId">
        <el-select v-model="dataForm.termId" placeholder="请选择学期" clearable>
          <el-option
                  v-for="term in termList"
                  :value="term.id"
                  :label="term.termName"
                  :key="term.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="考核范围" prop="assessScope">
        <el-select v-model="dataForm.assessScope" placeholder="考核范围" clearable>
          <el-option label="班主任" :value=assessScope.HEADTEACHER></el-option>
          <el-option label="教师" :value=assessScope.TEACHER></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="考核名称" prop="assessName">
        <el-input v-model="dataForm.assessName" placeholder="考核名称"></el-input>
      </el-form-item>
      <el-form-item label="考核模板" prop="templateId">
        <el-select v-model="dataForm.assessTemplateId" placeholder="请选择考核模板"  @change="change" clearable>
          <el-option
                  v-for="template in templateList"
                  :value="template.id"
                  :label="template.templateName"
                  :key="template.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="截止时间" prop="deadline">
        <el-date-picker
                v-model="deadline"
                @change="selectEnrollDate()"
                type="datetime"
                placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { assessScope } from '@/constant'
export default {
  data () {
    return {
      visible: false,
      deadline: '',
      dataForm: {
        id: '',
        termId: '',
        termName: '',
        assessScope: '',
        assessStatus: '',
        schoolId: '',
        creator: '',
        updater: '',
        createDate: '',
        updateDate: '',
        deadline: '',
        assessName: '',
        assessTemplateId: ''
      },
      assessScope,
      termList: [],
      templateList: []
    }
  },
  computed: {
    dataRule () {
      return {
        assessScope: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        termId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deadline: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        assessName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        assessTemplateId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.deadline = [].toString()
        this.$refs.dataForm.resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    change () {
      this.$forceUpdate() // 其作用就是强制性刷新了一次
    },
    selectEnrollDate () {
      const date = new Date(this.deadline)
      this.dataForm.deadline = date.getTime()
      console.log(this.dataForm.deadline)
    },
    getTermList () {
      this.$http.get('/term/term/getTermList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.termList = res.data
      }).catch(() => {})
    },

    // 获取信息
    getInfo () {
      this.$http.get('/teacherAssess/assessTable/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        const date = new Date(this.dataForm.deadline)
        this.deadline = date.getTime()
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        console.log(this.dataForm.createDate)

        if (!valid) {
          return false
        }
        this.loading = this.$loading({
          lock: true,
          text: '处理中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.$http[!this.dataForm.id ? 'post' : 'put']('/teacherAssess/assessTable/', this.dataForm).then(({ data: res }) => {
          this.loading.close()
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false }),
    getTemplateList () {
      this.$http.get('/teacherAssess/assessTemplate/getTemplateList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.templateList = res.data
      }).catch(() => {})
    }
  },
  created () {
    this.getTermList()
    this.getTemplateList()
  }
}
</script>
